module.exports = __webpack_public_path__ + "88acc4be81521cdd8f7802fbcdeb808b.png";